import { IconDownloadOutline, IconUploadOutline } from '@ssc-ui-icons/icons-react';
import { isNumber } from 'lodash';
import React, { useEffect, useRef } from 'react';
import { Button, Modal } from 'ssc-ui-react';
import { ModalProps } from 'ssc-ui-react/typings/components/modal/types';

import { $gt } from '@/common/appCtx';

import style from '../index.module.less';
import Summary from './summary-info';

export default function BatchImportDialog(props: any) {
  const {
    showDialog,
    setShowDialog,
    timerRef,
    resultData,
    setResultData,
    importing,
    importError,
    cancelFetch,
    handleRetry,
    handleImportConfirm,
  } = props;

  const summary = {
    fail_cnt: resultData?.fail_cnt,
    success_cnt: resultData?.success_cnt,
    total_cnt: resultData?.total_cnt,
  };

  const listRef = useRef([]);
  useEffect(() => {
    listRef.current = resultData.list || [];
  }, [resultData.list]);

  const handleCancel = () => {
    // 不用ref，esc事件会有问题
    if (listRef.current.length === 0) {
      cancelFetch();
      clearTimeout(timerRef.current);
      setShowDialog(false);
      setResultData({});
      return;
    }

    Modal.confirm({
      title: $gt('Confirm'),
      content: $gt('Are you sure you want to leave? Import task will be terminated.'),
      onOk: () => {
        cancelFetch();
        setShowDialog(false);
        setResultData({});
      },
      closable: true,
    });
  };
  const handleReImport = () => {
    Modal.confirm({
      title: $gt('Confirm'),
      content: $gt('Are you sure you want upload new data? The new data will replace the existed data.'),
      onOk: () => {
        handleRetry && handleRetry();
      },
    });
  };
  const handleDownloadResult = () => {
    window.open(resultData.result_file_path);
  };

  const modalProps: ModalProps = {
    visible: true,
    width: 700,
    title: $gt('Batch Import'),
    onCancel: handleCancel,
    okButtonProps: {
      disabled: importing || importError,
    },
    onOk() {
      handleImportConfirm(resultData.list ?? [], summary);
      setShowDialog(false);
    },
  };

  const showFailedAction = () => {
    return isNumber(summary.fail_cnt) && summary.fail_cnt > 0;
  };

  return (
    <>
      {showDialog && (
        <Modal {...modalProps}>
          <div className={style.batchImportHeader}>
            <Summary {...summary} />
            <div className={style.batchImportHeaderAction}>
              <Button icon={<IconUploadOutline />} type="link" onClick={handleReImport} style={{ fontWeight: 400 }}>
                {$gt('Re-import')}
              </Button>
            </div>
          </div>
          {showFailedAction() && (
            <div className={style.batchImportFailedTips}>* {$gt('Failed items will not be submitted.')}</div>
          )}
        </Modal>
      )}
    </>
  );
}
